export const FINANCEIRO_PAGE = () => "/financeiro";
export const FIN_PAYABLES_PAGE = () => "/financeiro/contas-a-pagar";
export const FIN_RECEIVABLES_PAGE = () => "/financeiro/contas-a-receber";
/** Lista de títulos do tipo: a pagar ou a receber. */
export const FIN_ENTRIES_PAGE = (type: "PAGAR" | "RECEBER") =>
  type === "PAGAR" ? FIN_PAYABLES_PAGE() : FIN_RECEIVABLES_PAGE();
export const FIN_ENTRY_NEW_PAGE = (type?: "PAGAR" | "RECEBER") =>
  type ? `/financeiro/lancamentos/novo?tipo=${type}` : "/financeiro/lancamentos/novo";
export const FIN_ENTRY_PAGE = (id?: string) =>
  id ? `/financeiro/lancamentos/${id}` : "/financeiro/lancamentos/:id";
export const FIN_ENTRY_EDIT_PAGE = (id?: string) =>
  id ? `/financeiro/lancamentos/${id}/editar` : "/financeiro/lancamentos/:id/editar";
export const FIN_CASHFLOW_PAGE = () => "/financeiro/fluxo-de-caixa";
export const FIN_DRE_PAGE = () => "/financeiro/dre";
export const FIN_SETTINGS_PAGE = () => "/financeiro/cadastros";
/** Cadastros abertos numa aba: contas, categorias, contrapartes, recorrencias. */
export const FIN_SETTINGS_TAB_PAGE = (tab: string) => `/financeiro/cadastros?aba=${tab}`;
